const Logo = ({ dark = false }) => (
  <img
    src="/assets/logo.png"
    alt="Millennium Info Tech"
    data-testid={dark ? "footer-logo" : "nav-logo"}
    className={dark ? "h-11 w-auto bg-white rounded-lg px-3 py-1.5" : "h-11 w-auto"}
  />
);

export default Logo;
